'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { string, array } = propTypes;
const createReactClass = require('create-react-class');

const seoSearch = createReactClass({
  propTypes: {
    id: string,
    functionParams: array
  },

  makeItem( item, key ) {
    return (
      <li key={ key }>
        <a href={ '/' + item.pageName + '.html' } title={ item.pageTitle } dangerouslySetInnerHTML={{ __html: item.pageTitle }} />
        <br />
        <span dangerouslySetInnerHTML={{ __html: item.description }} />
      </li>
    );
  },

  render() {
    const { id, functionParams } = this.props;
    let feeds = '';
    try {
      feeds = require( '../../../../config/exports/search/' + functionParams[0] + '.json' );
    } catch ( e ) {
      //console.log( e );
    }

    if ( !( feeds && feeds.length )) return ( <span id={ id } /> );
    return (
      <ul id={ id } className="unstyled seoSearch">
        { feeds.map( this.makeItem ) }
      </ul>
    );
  }
});

module.exports = seoSearch;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/seoSearch.jsx